import dayjs from 'dayjs';
import { DATEFORMAT_LOCAL_STATE, DATEFORMAT_SHORT_ISO } from '@ps20-frontend/utils';

export function formatToBffWirksamkeitsbeginn(wirksamkeitsbeginn: string): string {
  return wirksamkeitsbeginn
    ? dayjs(wirksamkeitsbeginn, DATEFORMAT_LOCAL_STATE)
        .subtract(1, 'd')
        .format(DATEFORMAT_SHORT_ISO)
    : undefined;
}

export function formatToFEWirksamkeitsbeginn(wirksamkeitsbeginn: string): string {
  return wirksamkeitsbeginn
    ? dayjs(wirksamkeitsbeginn, DATEFORMAT_SHORT_ISO).add(1, 'd').format(DATEFORMAT_LOCAL_STATE)
    : undefined;
}
